import React from 'react';
import {concepts} from "fearless-common";
import {Alert, Button, Loading} from "fearless-common-ui";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from "moment/moment";
import {useNavigate} from "react-router";
import {routes} from '../../utils/routes';
import ProfilePicture from '../../components/ProfilePicture';
import {DataRow} from '../../components/layout';
import {standardDateTimeFormat} from '../../utils/momentHelpers';
import {ReadOnlyCustomFields} from '../../components/forms/UserCustomFields';
import useAuth from '../../components/hooks/useAuth';
import Pages from "../../components/layout/Pages";
import StandardIcons from "../../components/layout/StandardIcons";
import useTitle from "../../components/hooks/useTitle";
import headerToTitle from "../../utils/headerToTitle";
import CopyText from "../../components/layout/CopyText";
import useGet from "../../components/hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";

const labelSize = 3;
const header = [
    { label: 'My Account'},
    { label: concepts.PersonalInformation },
];

/**
 * Show the logged-in user's personal information
 */
export default function PersonalInformationView() {
    const { user, reloadUser } = useAuth()
    const navigate = useNavigate();
    const { data: link, isLoading, error } = useGet({
        endpoint: backendEndpoints.getReferralLink('account-page'),
    })
    useTitle(headerToTitle(header.map(h => h.label)))

    return (
        <Pages.UserBase header={header}>
            <Row>
                <Col md={2} className="position-relative">
                    {user && (
                        <ProfilePicture
                            user={user}
                            size="100%"
                            canEdit
                            onSuccess={reloadUser}
                        />
                    )}
                </Col>
                <Col>
                    <DataRow labelSize={labelSize} label="Name">{user?.first_name} {user?.last_name}</DataRow>
                    <DataRow labelSize={labelSize} label="Email">{user?.email || ''}</DataRow>
                    <DataRow labelSize={labelSize} label={concepts.Username}>{user?.username}</DataRow>
                    <DataRow labelSize={labelSize} label="Password">********</DataRow>
                    <div className="my-4" />

                    <DataRow labelSize={labelSize} label="Organization">{user?.organisation}</DataRow>
                    <DataRow labelSize={labelSize} label="Position">{user?.position}</DataRow>
                    <DataRow labelSize={labelSize} label={concepts.GroupName}>{user?.group_name}</DataRow>
                    <DataRow labelSize={labelSize} label="Member since">{moment(user?.created_at).format(standardDateTimeFormat)}</DataRow>
                    {user?.on_trial && (
                        <DataRow labelSize={labelSize} label="Trials ends at">{moment(user?.trial_ends_at).format(standardDateTimeFormat)}</DataRow>
                    )}
                    {user?.custom_fields && <ReadOnlyCustomFields customFields={user.custom_fields}/>}
                    <Button
                        size="lg"
                        onClick={() => navigate(routes.accountEdit)}
                        variant="secondary"
                        className="mt-3"
                    >
                        <div className="d-inline-flex align-items-center gap-2">
                            <span>Edit</span>
                            <StandardIcons.Edit className="position-relative" />
                        </div>
                    </Button>
                </Col>
            </Row>
            <hr />
            {moment() < moment('2025-05-25 23:59:59') && (
            <Row>
                <Col md={{ offset: 2 }}>
                    <h3>Referral link</h3>
                    <p>Refer a friend before May 25th 23:59:59 and get 6 more months for free</p>
                    {error && <Alert>{error}</Alert>}
                    {typeof link === 'string' && <CopyText text={link} />}
                    {isLoading && <Loading />}

                </Col>
            </Row>
            )}
        </Pages.UserBase>
    );
}

